// 기본 주차 레이아웃 — 좌 6칸 + 우 6칸 마주보기 (총 12면)
// ParkingLayoutDesigner 툴로 생성/수정 가능

const layout = {
  meta: {
    cols: 3,   // 열: 왼쪽 주차면 | 도로 | 오른쪽 주차면
    rows: 6,
    label: '기본 주차장',
  },
  cells: [
    // col=0: 왼쪽 주차면, col=1: 도로, col=2: 오른쪽 주차면
    { col: 0, row: 0, type: 'spot', spot_no: 'A01' },
    { col: 1, row: 0, type: 'road', spot_no: null },
    { col: 2, row: 0, type: 'spot', spot_no: 'B01' },

    { col: 0, row: 1, type: 'spot', spot_no: 'A02' },
    { col: 1, row: 1, type: 'road', spot_no: null },
    { col: 2, row: 1, type: 'spot', spot_no: 'B02' },

    { col: 0, row: 2, type: 'spot', spot_no: 'A03' },
    { col: 1, row: 2, type: 'road', spot_no: null },
    { col: 2, row: 2, type: 'spot', spot_no: 'B03' },

    { col: 0, row: 3, type: 'spot', spot_no: 'A04' },
    { col: 1, row: 3, type: 'road', spot_no: null },
    { col: 2, row: 3, type: 'spot', spot_no: 'B04' },

    { col: 0, row: 4, type: 'spot', spot_no: 'A05' },
    { col: 1, row: 4, type: 'road', spot_no: null },
    { col: 2, row: 4, type: 'spot', spot_no: 'B05' },

    { col: 0, row: 5, type: 'spot', spot_no: 'A06' },
    { col: 1, row: 5, type: 'road', spot_no: null },
    { col: 2, row: 5, type: 'spot', spot_no: 'B06' },
  ],
};

export default layout;
